import Link from 'next/link';
import { ComponentPropsWithoutRef, ComponentType } from 'react';
import './venue-card.scss';

type Props = ComponentPropsWithoutRef<'div'> & {
    icon: ComponentType<ComponentPropsWithoutRef<'svg'>>;
    href?: string;
};
export const VenueCardInfo = ({ icon: Icon, children, href, ...props }: Props) => {
    const Comp = href ? Link : 'span';
    return (
        <div className="venue-card__info" {...props}>
            {Icon && <Icon />}
            {/* @ts-expect-error Next.js link props typing issue */}
            <Comp {...(href ? { href } : {})}>{children}</Comp>
        </div>
    );
};
